import { Menu } from "@mui/icons-material";
import { Grid, InputLabel, Select, Toolbar } from "@mui/material";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeSelectProvider } from "../../../actions/providers";
import { StyledHeader } from "../../styled/layout";
import IconMenuHelp from "./iconHelp";
import IconToJira from "./iconToJira";
import IconUser from "./iconUser";

const HeaderAppBar = ({ open, handleDrawerToggle }) => {
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.providers);
  const roles = useSelector((state) => state.auth.roles);
  const prevSelectProvider = useRef();

  const handleChangeSelect = (event) => {
    dispatch(changeSelectProvider(event.target.value));
  };

  useEffect(() => {
    if (
      roles?.PRESTADOR &&
      !!prevSelectProvider.current &&
      providers.selectedProvider &&
      prevSelectProvider.current !== providers.selectedProvider
    ) {
      setTimeout(() => window.location.reload(), 200);
    }
  }, [prevSelectProvider, providers.selectedProvider]);

  return (
    <StyledHeader.AppBar position="fixed" open={open}>
      <Toolbar>
        <StyledHeader.IconButton
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          open={open}>
          <Menu />
        </StyledHeader.IconButton>

        {roles?.PRESTADOR && (
          <Grid item xs={10} lg={5}>
            <StyledHeader.FormControl variant="standard">
              <InputLabel>Prestador</InputLabel>
              <Select
                label="Prestador"
                onChange={handleChangeSelect}
                value={providers.selectedProvider || ""}>
                {providers.list.map((provider) => (
                  <StyledHeader.Option key={provider.id} value={provider.id}>
                    {provider.nombre}
                  </StyledHeader.Option>
                ))}
              </Select>
            </StyledHeader.FormControl>
          </Grid>
        )}

        <Grid container justifyContent="flex-end" />
        <IconToJira />
        <IconUser />
        <IconMenuHelp />
      </Toolbar>
    </StyledHeader.AppBar>
  );
};

export default HeaderAppBar;
